import webappPlatformApi from "../webapp-platform-api/webappPlatformApi";
import CustomError from "./errors/custom.error";

declare global {
  interface Window {
    APP_CONFIG: any;
  }
}

function generateURLSearchParams(params: any) {
  if (params == null || Array.isArray(params) || typeof params != "object") {
    return "";
  }

  const data = Object.entries(params)
    .filter(([_, v]) => v != null)
    .reduce((r, [k, v]) => {
      r[k] = v;
      return r;
    }, {} as any);

  if (!Object.keys(data).length) return "";

  return "?" + new URLSearchParams(data);
}

async function fetchJSON(
  url: string,
  method: string = "GET",
  config: any = {}
) {
  const response = await fetch(url, {
    method,
    ...config,
    headers: {
      ...config.headers,
      "Content-Type": "application/json",
    },
  });

  if (!response.ok) {
    throw new CustomError(response.status, response.statusText);
  }

  return response;
}

function postJSON(url: string, params: any, headers: any = {}) {
  return fetchJSON(url, "POST", { body: JSON.stringify(params), headers });
}

function deleteReq(url: string, params: any, headers: any = {}) {
  return fetchJSON(url + generateURLSearchParams(params), "DELETE", {
    headers,
  });
}

function getJSON(url: string, params: Object | undefined, headers: any = {}) {
  return fetchJSON(url + generateURLSearchParams(params), "GET", { headers });
}

const API_URL = window?.APP_CONFIG?.API_URL;

function BackendService() {
  return {
    findAllDevice: async () => {
      await webappPlatformApi.auth.refreshTokens();
      const response = await getJSON(
        `${API_URL}/device/list`,
        undefined,
        webappPlatformApi.auth.requestHeaders
      );
      return response.json();
    },
    findAllGroup: async () => {
      await webappPlatformApi.auth.refreshTokens();
      const response = await getJSON(
        `${API_URL}/group/list`,
        undefined,
        webappPlatformApi.auth.requestHeaders
      );
      return response.json();
    },
    saveDeviceToGroup: async (
      deviceId: string,
      deviceType: string,
      groupId?: string
    ) => {
      await webappPlatformApi.auth.refreshTokens();
      await postJSON(
        `${API_URL}/device`,
        {
          deviceId,
          deviceType,
          groupId,
        },
        webappPlatformApi.auth.requestHeaders
      );
      return true;
    },
    saveGroup: async (id: string | undefined, name: string, limit: number) => {
      await webappPlatformApi.auth.refreshTokens();
      const response = await postJSON(
        `${API_URL}/group`,
        {
          id,
          name,
          limit,
        },
        webappPlatformApi.auth.requestHeaders
      );
      return response.json();
    },
    removeGroup: async (id: string) => {
      await webappPlatformApi.auth.refreshTokens();
      await deleteReq(
        `${API_URL}/group/${id}`,
        undefined,
        webappPlatformApi.auth.requestHeaders
      );
      return true;
    },
  };
}

export default BackendService;
